import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IReduxState } from 'types/ReduxState';

interface IGlobalLoadingTask {
  taskId: string;
  id: string;
}

export interface IGlobalLoadingState {
  activeTasks: IGlobalLoadingTask[];
}

const initialState: IGlobalLoadingState = {
  activeTasks: [],
};

const globalLoadingSlice = createSlice({
  name: 'globalLoading',
  initialState,
  reducers: {
    startLoadingTask: (state, action: PayloadAction<IGlobalLoadingTask>) => {
      if (!state.activeTasks.includes(action.payload)) {
        state.activeTasks.push(action.payload);
      }
    },
    stopLoadingTask: (state, action: PayloadAction<IGlobalLoadingTask>) => {
      state.activeTasks = state.activeTasks.filter((task) => task.id !== action.payload.id);
    },
  },
});

export const { startLoadingTask, stopLoadingTask } = globalLoadingSlice.actions;

export const selectIsGloballyLoading = (state: IReduxState) =>  state.globalLoading.activeTasks.length > 0;

export default globalLoadingSlice.reducer;
